<template>
    <div>
		<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;"></div>
        <form v-else v-on:submit.prevent class="main_form_block">
			<div  style = "border:1px #e2e2e2 solid; padding:20px" class = "col-sm-11">
				<div v-if = "showisVendorList" class="form-group row">
					<div class="col-sm-12">
						<CampaignFormDropDown
							:isVendor = "showVendor"
							label = "Vendor"
							selection = "Vendor Selection"
							@showNextView = "showBrandFormView"
							isMultiSelect = "false"
							:vendorVal = "productVendor"
							:nonEditable = "isEditProductPage"
							:vendor_name = "vendor_name"
							:dataLoading="showVendorLoader"
							:dropdownList="vendorDropDownList"
							:selectedValue="master_id"
							:selectedList="[]"
							inputCols="col-sm-7 pr-5"
							placeholder="Vendor"
							:useMasterId='true'
						/>
					</div>
				</div>
				<div v-if = "showisBrandsList" class="form-group row">
					<div class="col-sm-12">
						<CampaignFormDropDown
							ref="multiselectRef"
							:isBrand = "showisBrandsList"
							label = "Brand"
							selection = "Brand Selection"
							@showNextView = "showProductsFormView"
							fromProduct = "true"
							isMultiSelect = "false"
							:brand_name = "brand_name"
							:nonEditable = "isEditProductPage"
							:dataLoading="showBrandLoader"
							:dropdownList="brandDropDownList"
							:selectedValue="brand_id"
							:selectedList="[]"
							calledFrom = "product"
							inputCols="col-sm-7 pr-5"
							placeholder="Brand"
						/>
					</div>
				</div>
				<div v-if = "showisProductList">
					<div class="form-group row">
						<label for="productName" class="col-sm-2 col-form-label">Name <sup>*</sup></label>
						<div class="col-sm-7 pr-5">
							<input type="text" placeholder="Name" v-model="productTitle" name="title" class="form-control" id="title" :class="{ 'is-invalid': submitted && !checkProductTitle }" autocomplete = "off">
							<span v-if="submitted && !checkProductTitle" class="invalid-feedback">This field is required</span>
						</div>
					</div>
					<!-- <div class="form-group row">
						<label for="productName" class="col-sm-2 col-form-label">Abb. Title <sup>*</sup></label>
						<div class="col-sm-7 pr-5">
							<input type="text" placeholder="Name" v-model="productAbbTitle" name="abbTitle" class="form-control" id="abbTitle" :class="{ 'is-invalid': submitted && !checkProductAbbTitle }" autocomplete = "off">
							<span v-if="submitted && !checkProductAbbTitle" class="invalid-feedback">{{!productAbbTitle?'This field is required':'Maximum char allowed is 40.'}}</span>
						</div>
					</div> -->

					<div class="form-group row">
						<label for="" class="col-sm-2 col-form-label">ASIN <sup>*</sup></label>
						<div class="col-sm-7 pr-5">
							<input type="text" placeholder="ASIN" v-model="productASIN" name="asin" class="form-control" id="asinNo" :class="{ 'is-invalid': (submitted && !checkAsin)}" @keyup="duplicateAsin = false" autocomplete = "off" maxlength="12">
							<span v-if="submitted && !checkAsin && !duplicateAsin" class="invalid-feedback">This field is required</span>
							<span v-if="submitted && !checkAsin && duplicateAsin" class="invalid-feedback">Provide unique value for asin</span>

						</div>
					</div>


					<!-- <div class="form-group row">
						<label for="" class="col-sm-2 col-form-label">Category</label>
						<div class="col-sm-7 pr-5">
							<input type="text" v-model="productCategory" class="form-control" autocomplete = "off">
						</div>

						<label for="" class="col-sm-2 col-form-label pl-5">Sub Category</label>
						<div class="col-sm-7 pr-5">
							<input type="text" v-model="productSubCategory" class="form-control" autocomplete = "off">
						</div>
					</div> -->
					<!-- <div class="form-group row">
						<label for="" class="col-sm-2 col-form-label">Sub Category</label>
						<div class="col-sm-5">
							<input type="text" v-model="productSubCategory" class="form-control">
						</div>
					</div> -->
					<div class="form-group row">
						<label for="" class="col-sm-2 col-form-label">Unit Price</label>
						<div class="col-sm-7 pr-5">
							<input type="text" placeholder="Unit price" v-model="productUnitPrice" class="form-control" id="productUnitPrice" :class="{ 'is-invalid': submitted && !checkFloat }" autocomplete = "off">
							<span v-if="submitted && !checkFloat" class="invalid-feedback">This field is invalid</span>
						</div>
					</div>

					<div class="form-group row">
						<label for="tags" class="col-sm-2 col-form-label">Bidding Strategy</label>
						<div class="col-sm-7 pr-5" >
							<!-- <select class="form-control" v-model="productBiddingStrategy">
								<option>Top of Search</option>
								<option>Product Pages</option>
								<option>Bottom of Search</option>
							</select> -->
							<multiselect
								v-model="productBiddingStrategy"
								:options="biddingStrategyList"
								:searchable="true"
								:taggable="false"
								ref="multiselect"
								open-direction="bottom"
								placeholder="Bidding strategy"
								class="form-control multi-dropdown col-md-12 select_filter"
								:multiple="false"
								selectLabel = ""
								selectedLabel = ""
									>
							</multiselect>
						</div>
					</div>

					<div class="form-group row">
						<label for="" class="col-sm-2 col-form-label">Rank</label>
						<div class="col-sm-7 pr-5">
							<input type="text" placeholder="Rank" v-model="productRank" class="form-control" autocomplete = "off">
						</div>
					</div>

					<div class="form-group row">
						<label for="" class="col-sm-2 col-form-label">Product Line Description</label>
						<div class="col-sm-7 pr-5">
							<textarea class="form-control" placeholder="Product line description" v-model="productLineDescription" style="height:100px;"></textarea>
						</div>
					</div>

					<div class="form-group row">
						<label for="" class="col-sm-2 col-form-label">ASIN Description</label>
						<div class="col-sm-7 pr-5">
							<textarea class="form-control" v-model="productAsinDescription" placeholder="ASIN description" style="height:100px;"></textarea>
						</div>
					</div>
				</div>

			</div>

			<div  v-if = "showisProductList">
				<div class="col-sm-11" style="border-bottom: 2px solid #115E67;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;margin-top:30px"><label style="margin: 0px;">Tags</label></div>
				<div style = "border:1px #e2e2e2 solid; padding:20px" class = "col-sm-11">

					<div class="form-group row">
						<label class="col-sm-2 col-form-label" for="name">Brand Tags</label>
						<div class = "col-sm-7 pr-5 product-tags">
							<multiselect
								v-model="brand_tag"
								:options="brand_tag_list"
								:searchable="true"
								ref="multiselect"
								label="title"
								track-by="title"
								@tag="addTag($event, 'brand')"
								open-direction="bottom"
								:taggable="true"
								placeholder="Brand tags"
								class="form-control multi-dropdown col-md-12 select_filter"
								:multiple="false"
								selectLabel = ""
								selectedLabel = ""
								id="brandTags"
									>
							</multiselect>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-2 col-form-label" for="name">Category Tags</label>
						<div class = "col-sm-7 pr-5 product-tags">
							<multiselect
								v-model="category_tag"
								:options="category_tags_List"
								:searchable="true"
								ref="multiselect"
								label="title"
								track-by="title"
								@tag="addTag($event, 'category')"
								open-direction="bottom"
								:taggable="true"
								placeholder="Category tags"
								class="form-control multi-dropdown col-md-12 select_filter"
								:multiple="false"
								selectLabel = ""
								selectedLabel = ""
								id="catTags"
									>
							</multiselect>
						</div>

					</div>
					<div class="form-group row">
						<label class="col-sm-2 col-form-label" for="name">Style Tags</label>
						<div class = "col-sm-7 pr-5 product-tags">
							<multiselect
								v-model="style_tag"
								:options="style_tags_List"
								:searchable="true"
								ref="multiselect"
								label="title"
								track-by="title"
								@tag="addTag($event, 'style')"
								open-direction="bottom"
								:taggable="true"
								placeholder="Style tags"
								class="form-control multi-dropdown col-md-12 select_filter"
								:multiple="false"
								id="styleTags"
								selectLabel = ""
								selectedLabel = ""
									>
							</multiselect>
						</div>
					</div>
					
					<div
						v-for="(input, index) in product_tag_list"
						:key="`customTag-${input.type}`"
						class="form-group row"
					>
						<div class="col-sm-2 col-form-label">
							<label for="name">{{getTagLabel(input.type)}} Tag</label>
						</div>
						<div class = "col-md-6">
							<multiselect
								v-model="input.title"
								ref="multiselect"
								:options="[input.title]"
								:placeholder="input.title"
								:disabled = "add_tags[input.type] == 'Edit'"
								track-by="name"
								@tag="addTag($event, input.type,input)"
								open-direction="bottom"
								:taggable="true"
								class="form-control multi-dropdown col-md-12 select_filter"
								:multiple="false"
									>
							</multiselect>
						</div>
						<div class = "col-md-2" >
							<button
								style="color:white;"
								id="delete"
								class="btn btn-primary"
								v-on:click="saveTagsForProducts(input.type,input)"
							>{{ add_tags[input.type] }}</button>
						</div>
					</div>
					
					<div class="form-group row">
						<label class="col-sm-2 col-form-label" for="name">New Tag</label>
						<div class = "col-sm-4 pr-5 product-tags">
							<multiselect
								v-model="new_tag"
								:options="new_tag_options"
								:searchable="true"
								ref="multiselect"
								label="name"
								track-by="name"
								:show-labels="false"
								@tag="addTag($event, 'tag')"
								open-direction="bottom"
								:taggable="true"
								:disabled = "add_tag == 'Edit'"
								class="form-control multi-dropdown col-md-12 select_filter"
								:multiple="false"
								id="newTag"
									>
							</multiselect>
							</div>
						<div class = "col-md-3" v-if = "new_tag">
							<input
								type="text"
								id="newTagTitle"
								class="new_tag_title"
								style = "padding: 7px 0px 5px 10px;"
								v-model="newTagTitle"
								placeholder="New Tag Title"/>
						
						</div>
						<div class = "col-md-2" v-if = "new_tag">
							<div v-if = "add_tag == 'Loading'" class="spinner-border"></div>
							<button
								v-else
								style="color:white;"
								id="delete"
								class="btn btn-primary"
								v-on:click="saveTagsForProducts('tagged_product')"
							>{{add_tag}}</button>
						</div>
					</div>




				</div>
				<!-- <div class="form-group row">
					<label for="" class="col-sm-2 col-form-label">ASIN Description</label>
					<div class="col-sm-5">
						<textarea class="form-control" v-model="productAsinDescription" style="height:100px;"></textarea>
					</div>
				</div> -->
			</div>
        </form>
        <AddProductKeywordGrid :keywordList="keywordList" @saveNewProduct="saveNewProduct" @editSelectedKeyword="editSelectedKeyword" @deleteSelectedKeyword="deleteSelectedKeyword" @resetSelectedProduct="resetSelectedProduct" v-if = "showisProductList && !showLoader"></AddProductKeywordGrid>
        <AddKeywordModal :selectedKeyword="selectedKeyword" @saveKeyword="addKeywordToObject" @resetSelectedKeyword="resetSelectedKeyword"></AddKeywordModal>
        <AddProductConfirmModal @closeModal="navigateToProductList"></AddProductConfirmModal>
    </div>
</template>

<script>
import AddProductKeywordGrid from '@/components/add-product/AddProductKeywordGrid'
import AddKeywordModal from '@/components/add-product/AddKeywordModal'
import AddProductConfirmModal from '@/components/add-product/AddProductConfirmModal'
import CampaignFormDropDown from '@/components/add-campaign/CampaignFormDropDownNew'
import Multiselect from "vue-multiselect";



export default {
    name:'AddProductForm',
    data() {
        return {
			biddingStrategyList:['Top of Search','Product Pages','Bottom of Search'],
            productTitle:'',
            productASIN:'',
            productStyleSize:'',
            productVendor:'',
            productCategory:'',
            productSubCategory:'',
            productUnitPrice:'',
            productTags:'',
            productBiddingStrategy:'',
            productRank:'',
            productLineDescription:'',
            productAsinDescription:'',
            keywordList: [],
            selectedKeyword: {},
			new_tag:null,
			newTagTitle:null,
			add_tag:'Save',
			update_tag:null,
			add_tags:[],
            submitted:false,
			showisBrandsList : false,
			showisProductList : false,
			showVendor : true,
			brand_id : '',
			vendor_id :'',
			showisVendorList : false,
			isEditProductPage : false,
			vendor_name : '',
			brand_name : '',
			showVendorLoader: false,
			showBrandLoader: false,
			showProductLoader: false,
			vendorDropDownList: [],
			brandDropDownList: [],
			productDropDownList: [],
			showLoader: false,
			category_tag: null,
			category_tags_List: [],
			style_tag: null,
			pg_tag:null,
			gl_tag:null,
			pg_tag_list:[],
			gl_tag_list:[],
			style_tags_List: [],
			brand_tag: null,
			brand_tag_list: [],
			master_id:'',
			add_tag_list:[],
			tag_list:[],
			new_tag_options: [],
			input_tag_list:[],
			new_tags: [
					{ name: 'Brand', value: 'brand_product'},
					{ name: 'Category', value: 'category_product'},
					{ name: 'Color', value: 'color_product'},
					{ name: 'Competitor', value: 'competitor_product'},
					{ name: 'Sub-Category', value: 'sub_category_product'},
					{ name: 'Style', value: 'style_product'},
					{ name: 'GL', value: 'gl_product'},
					{ name: 'Product Group', value: 'product_group_product'},
					{ name: 'Abbreviated Title', value: 'abbreviated_title_product'},
					{ name: 'Size', value: 'size_product'},
					{ name: 'Flavor', value: 'flavor_product'}
		],
			productAbbTitle:''
        }
    },
    components: {
        AddProductKeywordGrid,
        AddKeywordModal,
        AddProductConfirmModal,
		CampaignFormDropDown,
		Multiselect
    },
    computed: {
        checkProductTitle() {
            if (this.productTitle && this.productTitle.trim()) {
                return true
            }
            else {
                return false
            }
        },
		checkProductAbbTitle(){
			if (this.productAbbTitle && this.productAbbTitle.trim() && this.productAbbTitle.trim().length<41) {
                return true
            }
            else {
                return false
            }
		},
        checkAsin() {
            if (this.productASIN && this.productASIN.trim()) {
                return true
            }
            else {
                return false
            }
        },
        checkVendor() {
            if (this.productVendor || this.productVendor.trim()) {
                return true
            }
            else {
                return false
            }
        },
        checkFloat() {
             let demical = /^\$?\d+(,\d{3})*(\.\d{1,2})?$/
			 if(this.productUnitPrice.charAt(0) == " " || this.productUnitPrice.charAt(this.productUnitPrice.length -1) == " "){
				 this.productUnitPrice = this.productUnitPrice.trim()
			 }
            if (this.productUnitPrice.match(demical) || !this.productUnitPrice.trim()) {
                return true
            }
            else {
                return false
            }
        },
			product_tag_list() {
				let l = this.$store.state.product.tagList
				let inputs = []
				this.new_tag_options = []

				if(l) {
					l.forEach(tag => {
						let input = inputs.find(tag_input => {return (tag_input.type == tag.type)})
						let default_input = this.input_tag_list.find(tag_input => {return (tag_input.value == tag.type)})
						if (!input && !default_input) {
							console.log('TAGG',tag)
							tag.value=tag.title
							if(tag.id) {
								this.add_tags[tag.type] = 'Edit'
							}
							inputs.push(tag)
							this.input_tag_list.push({value:tag.type})
						}
				})}
				
				this.new_tags.forEach(tag => {
					let has_input = this.input_tag_list.find(new_input => (new_input.value == tag.value))
					if(!has_input) {
						this.new_tag_options.push(tag)
					}
				})
				return inputs
			},
        editSelectedProduct: {
            set(val) {
                this.$store.state.product.editSelectedProduct = val
            },
            get() {
                return this.$store.state.product.editSelectedProduct;
            }
        },
        productId() {
            return this.$route.params.productId
        }
    },
	mounted() {
		this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'AddEditProduct'})
		this.add_tags['flavor_product'] = 'Save'
		this.add_tags['color_product'] = 'Save'
		this.add_tags['competitor_product'] = 'Save'
		this.add_tags['sub_category_product'] = 'Save'
		this.add_tags['gl_product'] = 'Save'
		this.add_tags['product_group_product'] = 'Save'
		this.add_tags['abbreviated_title_product'] = 'Save'
		this.add_tags['size_product'] = 'Save'
		let vm = this;
		if (this.editSelectedProduct && this.editSelectedProduct.id && this.editSelectedProduct.id == this.productId) {
			this.showLoader = true;
			vm.$store.dispatch('product/getProductById', { productId: vm.productId, type : 'id', entityType: vm.$store.state.product.editSelectedProduct.entity_type }).then((res) => {
				this.getTagList()
				this.isEditProductPage = true
				vm.initialiseComponent(res)
			})
		}
		else if (this.productId > -1) {
			this.showLoader = true;
			this.isEditProductPage = true
			this.$store.dispatch('product/getProductById', { productId: this.productId, type : 'id'}).then((res) => {
				this.getTagList()
				if(res && res.length){
					vm.initialiseComponent(res[0]);
				}
				else{
					vm.initialiseComponent(res);
				}
			})
		}
		else{
			this.getTagList()
			this.showisVendorList = true
			const vm = this;
			vm.showVendorList(null, res => {
				vm.vendorDropDownList = res
			})
		}
	},
    methods: {
		saveTagsForProducts(type,input){
			let vm = this;
			let payload = {
				product_id:[{id:this.productId}],
				type:type,
				entityType : this.$store.state.product.currentTagProduct.entity_type,
				new_tag: {
					title:this.newTagTitle,
					value:type,
				}
			}
			if(this.checkAction(type)){
				if(type == 'tagged_product'){
					this.new_tag.title = this.newTagTitle
					payload.new_tag = this.new_tag
					payload.new_tag.type = type
					this.add_tag = 'Loading'
					console.log('TAGGED_PR',payload)
				} else {
					payload.new_tag = input
					payload.new_tag.value = type
					this.add_tags[type] = 'Loading'
				}
				this.$store.dispatch("product/addTags", payload ).then((res) => {
					if(type == 'tagged_product'){
						vm.add_tag = 'Save'
						vm.new_tag = ''
						vm.newTagTitle = ''
						this.add_tag_list = []
						
						this.getTagsList()
					} else {
						vm.add_tags[type] = 'Edit'
						this.$mount();
					}
				})
			}
		},
		getProductTagsList(){
			console.log('START_PRODUCT_TAG_LIST')
			this.$store.dispatch("product/getTagsForProduct").then((res) => {
				console.log('TAG_LIST: ',res.tags)
				this.tag_list = res.tags
			})
		},
		checkAction(type){
			console.log('CHECK_ACTION', type, this.add_tags[type])
			if(type == 'tagged_product'){
				if(this.add_tag == 'Edit'){
					if(this.new_tag){
						this.new_tag = this.add_tag_list.find(e => e.title == this.new_tag.title)
					}
					this.add_tag = 'Save';
					return false
				}
				else{
					return true
				}
			} else {
				if(this.add_tags[type] == 'Edit'){
					this.update_tag = this.input_tag_list.find(new_input => new_input.value == type)
					this.add_tags[type] = 'Save';
					this.$mount();
					return false
				}
				else{
					return true
				}
			}

		},
		showVendorList(data, callback){
			this.showisVendorList = true
			this.showisBrandsList = false
			this.showisProductList = false
			this.showRemainingForm = false
			this.fetchVendorList(callback)
		},
		fetchVendorList(callback){
			const vm = this;
			this.showVendorLoader = true;
			this.$store.dispatch("getAccountVendors").then(res=>{
				  vm.showVendorLoader = false
				  let list = res.filter(e=>e.vendor_name && e.id && e.vendor_id);
				  callback ? callback.call(vm, list) : ''
		    })
		},
		showBrandFormView(data, callback) {

			if(!this.isEditProductPage){
				this.brand_id=''
				if(Object.keys(this.$refs).length){
					this.$refs["multiselectRef"].resetModalValue()
				}
			}
			
			if(data !=0){
				this.showisBrandsList = true;
				this.showisProductList = false;
				this.showRemainingForm = false
				if(data && Object.keys(data) && Object.keys(data)[0]!='0'){
					this.productVendor = data
				}
				else{
					let selectedVendor = this.vendorDropDownList.filter(item=>(item.vendor_id == data && item.id == this.master_id))
					if(selectedVendor.length){
						this.productVendor = selectedVendor[0]
					}
				}

				this.fetchBrandList(data, callback)
			}
			else{
				this.showisBrandsList = false;
				this.showisProductList = false;
			}
		},
		fetchBrandList(vendorId, callback){
			
			const vm = this;
			// let vendor = vendorId && vendorId.id || vendorId
			let vendor = vendorId && vendorId.vendor_id || vendorId
			// let payload = { vendorId:vendor  };
			let payload = { vendor_id:vendor  };
			this.showBrandLoader = true;
			this.$store
				.dispatch("getAllBrandProfile", payload)
				.then(res => {
					vm.showBrandLoader = false;
					vm.brandDropDownList = res;
					callback ? callback.call(vm, res) : '';
				});
		},
		showProductsFormView(data, callback) {

			if(data !=0){
			this.brand_id = data && data.id || data;
			this.showisProductList = true
			}
			else{
				this.showisProductList = false
			}
		},
        initialiseComponent(item) {
			this.$store.commit("product/updateCurrentTagProduct", item)
            this.productTitle = (item.product_title && item.product_title.trim()) ? item.product_title.trim() : ''
			this.productAbbTitle = (item.abbrev_title && item.abbrev_title.trim()) ? item.abbrev_title.trim() : ''
            this.productASIN = (item.asin && item.asin.trim()) ? item.asin.trim() : ''
            this.productVendor = item.vendor_name ? item.vendor_name.trim() : ''
            this.productStyleSize = (item.model_style_number && item.model_style_number.trim()) ? item.model_style_number.trim() : ''
        //    this.productCategory = item.category ? item.category.trim() : ''
            this.productUnitPrice = (item.list_price || ' ') + ''.trim()
        //    this.productSubCategory = item.sub_category ? item.sub_category.trim() : ''
        //    this.productTags = item.tags ? item.tags.trim() : ''
            this.productBiddingStrategy = item.bidding_strategy ? item.bidding_strategy.trim() : ''
            this.productRank = item.ranktext ? item.ranktext.trim() : ''
            this.productLineDescription = item.productlinedescription ? item.productlinedescription.trim() : ''
			this.productAsinDescription = item.asindescription ? item.asindescription.trim() : ''
			this.category_tag = item.category_tag ? item.category_tag : null
			this.style_tag = item.style ? item.style : null
            this.brand_tag = item.brand_tag ? item.brand_tag : null
			this.pg_tag = item.product_group_tag ? item.product_group_tag : null
            this.gl_tag = item.gl_tag ? item.gl_tag : null
            
            try{
				this.keywordList = item.keywordjson ? JSON.parse(item.keywordjson) : []// TODO:
			} catch(e){
				// Fix for corrupted data
				if(item.keywordjson.indexOf("{\"{") == 0){
					item.keywordjson = "[" + JSON.parse(item.keywordjson.substring(1, item.keywordjson.length - 1)) + "]";
					let keywordList = JSON.parse(item.keywordjson);
					keywordList = keywordList.map((v,k)=>{
						v.keyword = v.keyword[0].split("\n")
						return v;
					})
					this.keywordList = keywordList;
				}
				console.log(e, this.keywordList);
			}
			this.vendor_name = item.vendor_name
			this.brand_name = item.profile_brand_name
			this.showisVendorList = true
			this.vendor_id = item.vendor_id
			this.master_id = item.vendor_master_id
			//this.vendor_id = item.go_vendor_cd
			this.brand_id = item.profile_id
			const vm = this
			
			vm.showVendorList(null, res => {
				vm.vendorDropDownList = res;
				vm.showBrandFormView(vm.vendor_id, ()=>{
					vm.showProductsFormView(vm.brand_id)
					vm.showLoader = false;
					setTimeout( () => { vm.showSpinner = false }, 0 );
				})
			})
			//update keyword list as per common type
			this.keywordList = this.updateList(JSON.parse(JSON.stringify(this.keywordList)))
		},
		updateList(keywordList){
			for(let i=0;i<keywordList.length-1;i++){
				for(let j=i+1;j<keywordList.length;j++){
					if(keywordList[i].type==keywordList[j].type){
						keywordList[i].keyword = [...keywordList[i].keyword,...keywordList[j].keyword]
						keywordList.splice(j,1)
						i=i-1
					}
				}
			}
			return keywordList
		},
        addKeywordToObject(keyword) {
            if (keyword.keywordIndex > -1) {
				this.keywordList.splice(keyword.keywordIndex, 1)
			}
				// this.keywordList.push(keyword)
				let index = this.keywordList.findIndex(item=> {
					return item['type']==keyword['type']
				})
				if(index>-1){
					this.keywordList[index]['keyword'] = [...this.keywordList[index]['keyword'],...keyword['keyword']]
				}
				else {
					this.keywordList.push(keyword)
				}
        },
        resetAllValues() {
            this.productTitle = ''
            this.productASIN = ''
            this.productStyleSize = ''
            this.productVendor = ''
            this.productCategory = ''
            this.productSubCategory = ''
            this.productUnitPrice = ''
            this.productTags = ''
            this.productBiddingStrategy = ''
            this.productRank = ''
            this.productLineDescription = ''
            this.productAsinDescription = ''
            this.keywordList =  []
            this.selectedKeyword =  {}
            this.editSelectedProduct = {}
        },
        editSelectedKeyword(item) {
			//
            this.selectedKeyword = item
        },
        deleteSelectedKeyword(keywordIndex) {
            this.keywordList.splice(keywordIndex, 1);
        },
        resetSelectedProduct() {
            this.resetAllValues();
        },
		saveNewProduct() {
			let vm = this
			this.submitted = true;
			//code for abb title as mandatory field(commented for now)
			//pg gl tag functionality commented for now
			// if (this.checkProductTitle && this.checkAsin && this.checkFloat && this.checkProductAbbTitle)
			if (this.checkProductTitle && this.checkAsin && this.checkFloat) {
				vm.submitCall()
			}
			else {
				if (!this.checkProductTitle) {
					$('#title').focus()
				}
				// else if(!this.checkProductAbbTitle){
				// 	$('#abbTitle').focus()
				// }
				else if (!this.checkAsin) {
					$('#asinNo').focus()
				}
				else if (!this.checkVendor) {
					$('#vendorFilter').focus()
				}
				else if (!this.checkFloat) {
					$('#productUnitPrice').focus()
				}
				return
			}
		},
        resetSelectedKeyword() {
            this.selectedKeyword = {}
        },
		navigateToProductList() {
			this.resetAllValues()
			this.$store.commit("clearProductList")
			this.$router.push({ path:'/productList' })
		},
        submitCall() {
            let date = new Date()
            let vm = this;


			// let key = ''
			// this.keywordList.map((res) => {
			// 	key = key.concat(res.keyword)
			// 	key = key.concat(' ')
			// })
			// let keyList = key.replace('/s' ,',')
			let newProductObject = {
                productTitle: this.productTitle,
                asin: this.$store.state.product.currentTagProduct ? this.$store.state.product.currentTagProduct.asin : this.productASIN,
                vendorName: this.vendor_name,
				// vendor_id:(this.productVendor  && this.productVendor.id || this.productVendor) ,
				vendor_id:(this.productVendor  && this.productVendor.id || ''),
                modelStyleNumber: this.productStyleSize,
                category: this.productCategory,
                unitPrice: this.productUnitPrice,
                subCategory: this.productSubCategory,
                tags: this.productTags,
                biddingStrategy: this.productBiddingStrategy,
                rankText: this.productRank,
                productLineDescription: this.productLineDescription,
                asinDescription: this.productAsinDescription,
				brand_id : this.brand_id,
				entityType : this.$store.state.product.currentTagProduct.entity_type,
				category_tag: this.category_tag,
				style_tag: this.style_tag,
				brand_tag: this.brand_tag,
				tag_list: this.add_tag_list,
				// gl_tag:this.gl_tag,
				// product_group_tag:this.pg_tag,
				// abbrev_title:this.productAbbTitle,
                keywords: this.keywordList,
            }

			console.log('SUBMIT_PRODUCT',newProductObject)

			if(newProductObject.vendor_id){
				let checkIsVendorPresentInList = this.vendorDropDownList.filter(e=>e.id == newProductObject.vendor_id)
				if(checkIsVendorPresentInList && checkIsVendorPresentInList.length!=0){
					newProductObject.isUpdateVendorForHeader = true
				}
				else{
					newProductObject.isUpdateVendorForHeader = false
				}

			}


            if (this.editSelectedKeyword && this.editSelectedKeyword.id > -1) {
                newProductObject['id'] = this.editSelectedKeyword.id
            }
            else if (parseInt(this.productId) > -1) {
                newProductObject['id'] = parseInt(this.productId)
            }
            // console.log(JSON.stringify(newProductObject))
			this.showLoader = true
            this.$store.dispatch('product/addNewProduct', { data: newProductObject}).then((response)=>{

				if (response.response && response.response.status == "409") {
					vm.productASIN = ''
					vm.checkAsin = false;
					$('#asinNo').focus();
					vm.duplicateAsin = true;
					vm.showLoader = false;
					vm.showVendor = true;
					// vm.vendor_id = (vm.productVendor  && vm.productVendor.id || this.productVendor)
					vm.master_id = (vm.productVendor  && vm.productVendor.id || '')
					vm.vendor_id = (vm.productVendor  && vm.productVendor.vendor_id || '')
				}else{
					$('#addProductSuccessModal').modal('show');
				}
			})
        },
		getTagLabel(data) {
			return this.new_tags.find(tag => tag.value == data).name
		},
		getTagList(product_id,entity){
			let vm = this;
			console.log('ADDPRODFORM_GETTING_TAGS')
			this.$store.dispatch("product/getTagsForProduct").then((res) => {
				console.log('RESPONSE', res)
				vm.tag_list = res.tags
			})
		},
		getTagsList(){
			console.log('ADDPRODFORM_TAG_LIST')
			this.$store.dispatch("product/getTagsForProduct").then((res) => {
				console.log('TAGS_RESPONSE', res)
				this.tag_list = res.tags
			})
		},
		addTag(name, type, input){

			var pay = { title : name, id:''}

			console.log('ADDING_TAG')
			console.log(name,type,input)

			if(type == 'category'){
				this.category_tag = pay
				this.category_tags_List.push(pay)
			}
			else if(type == 'brand'){
				this.brand_tag = pay
				this.brand_tag_list.push(pay)
			}
			else if(type == 'style'){
				this.style_tag = pay
				this.style_tags_List.push(pay)
			}
			else if(type == 'pg'){
				this.pg_tag = pay
				this.pg_tag_list.push(pay)
			}
				else if(type == 'tag'){
					this.new_tag = pay
					this.new_tag.title = this.newTagTitle
					this.new_tag.type = this.new_tag.val
					this.add_tag_list.push(pay)
				} else {
					input.id = null
					input.title = name
					input.type = type
					input.value = type
					this.update_tag = input
				}
			},
    }
}
</script>

<style lang="scss">

.product-tags {
	.multiselect__tag{
		text-transform:none !important
	}
}
.product-tags {
	.multiselect__single{
		text-transform: none !important;
		overflow: hidden;
	}
}
.product-tags {
	.multiselect__option span{
		text-transform: none !important;
	}
}


</style>
